// extracted by mini-css-extract-plugin
export var externalLink = "_d5-0";
export var internalLinkLabel = "_d5-1";